//GLOBAL - components from npm
import React from 'react';

//STYLES
import './h6.scss';

//COMPONENTS


//SERVICES - api, conectors...


//GLOBAL STATE - redux, env...


//ASSETS - icons, images...


export default function H6({
  className,
  children,
  weight,
  color
}) {

  //GENERAL
  const mainClassName = 'typography-h6'

  //STATES


  //REDUX - Selectors


  //FUNCTIONS


  //USE EFFECTS


  return (
    <h6 className={`${mainClassName} ${className ? className : ''} ${weight ? `${mainClassName}--${weight}` : ''} ${color ? `${mainClassName}--color-${color}` : ''}`}>
      {children}
    </h6>
  )
}
